import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";

import { environment } from "../../../environments/environment";
import { CacheType } from "@app/shared/models/enums/cachetype.enum";
import { CacheOptions } from "@app/shared/models/cacheOptions.model";

@Injectable()
export class CacheService {

    static readonly CACHE_API_GET_PATH = `${environment.baseURL}/api/cache`;

    constructor(private http: HttpClient) {
    }

    clearCache(cacheOptions: CacheOptions, cacheType: CacheType) {
        let params = new HttpParams();
        params = params.set('cacheType', cacheType.toString());

        return this.http.post<null>(`${CacheService.CACHE_API_GET_PATH}/clear`, cacheOptions , {params: params});
    }
}
